export default "__VITE_ASSET__DD7nuS3Q__"